import { useContext, useMemo } from 'react';
import { PageContext } from '../context/PageProvider';
import { useFrame } from '~/shared/utils';
import { Pages } from '~/lib';
import { extractPageSize } from '~/shared/utils/plp';

export const usePage = (): Pages => {
    const { page } = useContext(PageContext);
    const { data: frame } = useFrame();

    const productListPageSize = useMemo(
        () => extractPageSize(page, frame),
        [page.type, page.productListPageSize],
    );

    return {
        ...page,
        productListPageSize,
    };
};
